/* Northtac theme — facets.js (collection filtering + sorting with section re-render) */

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => this.onSubmitHandler(event), 500);
  }

  connectedCallback() {
    const form = this.querySelector('form');
    if (form) form.addEventListener('input', this.debouncedOnSubmit);
    window.addEventListener('popstate', () => {
      FacetFiltersForm.renderPage(window.location.search.slice(1), false);
    });
  }

  static getSectionId() {
    const grid = document.getElementById('CollectionProductGrid');
    return grid ? grid.dataset.sectionId : null;
  }

  static renderPage(searchParams, updateURLHash = true) {
    const sectionId = FacetFiltersForm.getSectionId();
    if (!sectionId) return;
    document.getElementById('CollectionProductGrid').classList.add('is-loading');
    const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        ['CollectionProductGrid', 'CollectionToolbar', 'CollectionFacets', 'ActiveFacets', 'CollectionPagination', 'CollectionPills'].forEach((id) => {
          const target = document.getElementById(id);
          const source = html.getElementById(id);
          if (target && source) target.innerHTML = source.innerHTML;
        });
        document.getElementById('CollectionProductGrid').classList.remove('is-loading');
        if (updateURLHash) {
          history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams ? '?' + searchParams : ''}`);
        }
        // No scrollIntoView here: when the result grid is taller than the
        // viewport it yanked the page down after every filter change.
        // Filtering should never move the page.
      })
      .catch(() => {
        document.getElementById('CollectionProductGrid').classList.remove('is-loading');
      });
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    const params = new URLSearchParams();
    for (const [key, value] of formData.entries()) {
      if (value !== '') params.append(key, value);
    }
    return params.toString();
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const forms = document.querySelectorAll('facet-filters-form form');
    let searchParams = '';
    forms.forEach((form) => {
      if (form.contains(event.target)) searchParams = this.createSearchParams(form);
    });
    FacetFiltersForm.renderPage(searchParams);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    const url = new URL(event.currentTarget.href);
    FacetFiltersForm.renderPage(url.searchParams.toString());
  }
}
customElements.define('facet-filters-form', FacetFiltersForm);

/* Active filter pills + "All" quick-filter pill (rendered links) */
document.addEventListener('click', (event) => {
  const pill = event.target.closest('[data-facet-link]');
  if (!pill) return;
  event.preventDefault();
  const url = new URL(pill.href, window.location.origin);
  FacetFiltersForm.renderPage(url.searchParams.toString());
});

/* Quick-filter pills: SINGLE-select within their filter group — the clicked
   value REPLACES any current selection of that param (the sidebar stays
   multi-select; its picks light these pills up via the re-rendered row).
   Other filter groups and sorting are preserved. Clicking the pill that is
   the sole active value clears it (back to All). */
document.addEventListener('click', (event) => {
  const pill = event.target.closest('[data-pill-single]');
  if (!pill) return;
  event.preventDefault();
  const param = pill.dataset.pillParam;
  const value = pill.dataset.pillValue;
  const params = new URLSearchParams(window.location.search);
  const current = params.getAll(param);
  params.delete(param);
  if (!(current.length === 1 && current[0] === value)) params.append(param, value);
  params.delete('page');
  FacetFiltersForm.renderPage(params.toString());
});

/* Sort select (outside the facet form) */
document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-sort-select]');
  if (!select) return;
  const params = new URLSearchParams(window.location.search);
  params.set('sort_by', select.value);
  FacetFiltersForm.renderPage(params.toString());
});

/* Grid density select (client-side only) */
document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-grid-select]');
  if (!select) return;
  const grid = document.querySelector('#CollectionProductGrid .product-grid');
  if (grid) grid.style.setProperty('--grid-cols', select.value);
});
